import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './image-placemat-cta.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class ImagePlacematCta extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      items: { type: Array },
    }
  }

  constructor() {
    super()
    this.items = []
  }

  renderItem(item) {
    return html`<div
      class="hf-image-placemat-cta__wrapper"
      style="
      --placemat-bg-image: url(${item.image.src});
      --placemat-mobile-bg-image: url(${item.mobile_image.src});
      "
    >
      <hf-cta-card
        heading=${item.title}
        bodytext=${item.bodytext}
        link=${JSON.stringify(item.link)}
        class="hf-image-placemat-cta__card"
        styleclass="image-placemat-cta"
      ></hf-cta-card>
    </div>`
  }

  render() {
    return html`
      <div
        class=${classMap({
          'hf-image-placemat-cta': true,
          'hf-image-placemat-cta--single': this.items.length === 1,
        })}
      >
        ${this.items.map(item => this.renderItem(item))}
      </div>
    `
  }
}

customElements.define('hf-image-placemat-cta', ImagePlacematCta)
